import { render, staticRenderFns } from "./StatisticsCardLine.vue?vue&type=template&id=5bd8a673&"
import script from "./StatisticsCardLine.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports